// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
  /*  */
  .maincontainer{
    display: flex;
    height: 100vh;
    overflow: hidden;
  }
  .imagecontainer{
    flex: 2 1;
    display: block;
  }
  
  .leftcontainer{
    flex: 1 1;
    background: linear-gradient(to top, #282B4E 50%, #383C6A 100%);
    color: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 24px;
    overflow-y: auto;
  }
  
  /* TextField Styles */
  .textField input {
    color: #fff;
    background: transparent;

  }
  
  .textField label {
    color: #808080;
  }
  
  .textField .MuiOutlinedInput-root {
    border-radius: 8px;
  }
  
  .textField .MuiOutlinedInput-root fieldset {
    border-color: #808080;
  }
  
  .textField .MuiOutlinedInput-root:hover fieldset {
    border-color: #A9A9A9;
  }
  
  .textField .MuiOutlinedInput-root.Mui-focused fieldset {
    border-color: #808080;
  }
  
  .textField .MuiInputLabel-root {
    color: #808080;
  }
  
  .textField .MuiInputLabel-root.Mui-focused {
    color: #808080;
  }
  
  .textField input:-webkit-autofill {
    -webkit-box-shadow: 0 0 0px 1000px #383C6A inset;
    -webkit-text-fill-color: #fff;
  }
  
  .textField input:-webkit-autofill:focus {
    -webkit-box-shadow: 0 0 0px 1000px #383C6A  inset;
    -webkit-text-fill-color: #fff;
  }
  
  /* Password Strength Indicator */
  .passwordStrength {
    display: flex;
    align-items: center;
    gap: 5px;
    /* margin-top: 33px; */
  }
  .passwordBar {
    height: 5px;
    width: 25px;
    border-radius: 2px;
    margin-left: 5px;
    background-color: #808080;
  }
  
  .passwordBar.strong {
    background-color: #3FC014;
  }
  
  .passwordBar.medium {
    background-color: #FFFF00;
  }
  .passwordBar.weak {
    background-color: #b10c0c;
  }
  .passwordMessage .weak {
  color: red;
}

.passwordMessage .medium {
  color: yellow;
}

.passwordMessage .strong {
  color: green;
}
  
  /* Button Styles */
  .MuiButtonBase-root.submitButton {
    background-color: #69319d;
    color: #fff;
    padding: 10px;
    font-family: var(--font-family-primary);
    font-size: 14px;
    font-weight: 400;
    border-radius: 8px;
    text-transform: none;
  }
  
  .MuiButtonBase-root.submitButton:hover {
    background-color: #53297d;
  }
  
  .MuiTypography-root.policyText {
    font-family: var(--font-family-primary);
    font-size: 14px;
    font-weight: 400;
    text-align: center;
    margin-top: 12px;
 
  }
  .MuiTypography-root.policyText .Privacy{
    color: #fff;
    text-decoration: none;
    margin-left: 4px;

  }
  .MuiTypography-root.policyText .Terms{
    color: #fff;
    text-decoration: none;
    margin-left: 2px;
    margin-right: 4px;

  }
  .MuiInputBase-root{
    background-color: #282B4E ;

  }
 .VisibilityOff{
    color: #8E37E6;
 }
 .Visibility{
    color: #8E37E6;

 }
   .MuiTypography-root.login-short{
    font-size: 12px;
    font-family: var(--font-family-primary);
    font-weight: 400;
    color: #F0F0F0;
    margin-bottom: 10px;
  }
  .login-resend{
    font-size: 13px;
    font-family: var(--font-family-primary);
    font-weight: 600;
    color: #BD77FF;
    cursor: pointer;
    margin-bottom: 30px;
    text-decoration: underline;
  }
  .login-resend-timer{
    color: #fff;
    margin-left: 5px;
    text-decoration: underline;
    cursor: pointer;
  }
  .MuiTypography-root.login-title{
    font-size: 16px;
    font-family: var(--font-family-primary);
    font-weight: 400;
    color: #F0F0F0;
    margin-bottom: 20px;
    line-height: 1;
  }
 .MuiBox-root.imagecontainer{
  background-repeat: no-repeat;
  object-fit: cover;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
  background-image: url('https://showcasaai.blob.core.windows.net/applicationasset/1440_Image.svg');
  @media screen and (min-width: 1024px) and (max-width: 1440px) {
   background-image: url('https://showcasaai.blob.core.windows.net/applicationasset/1440_Image.svg');
  }
  @media screen and (min-width: 1441px) {
    background-image: url('https://showcasaai.blob.core.windows.net/applicationasset/1920_Image.svg');
   }
}
.MuiBox-root.login-container{
    display: flex;
    flex-direction: column;
    /* align-items: center; */
    justify-content: center;
    gap: 10px;
}
.otp-input {
  width: 48px;
  height: 56px;
  text-align: center;
  font-size: 24px;
  font-weight: 600;
  border: 2px solid #4A4E7C;
  border-radius: 8px;
  outline: none;
  transition: border-color 0.2s;
  background-color: #4A4E7C;
  color: #fff;
}

.otp-input:focus {
  border-color: #6a6fad; 
}
.MuiBox-root.verification-container{
    display: flex;
    flex-direction: column;
    gap: 20px;
    width: 100%;
}
.textField.verification-email .MuiFormHelperText-root {
    margin-bottom: 0px;
}
.MuiTypography-root.extra-login-text{
   font-size: 14px;
  font-family: var(--font-family-primary);
  font-weight: 400;
}
.login-resend.disabled {
  opacity: 0.6;
  cursor: not-allowed;
 /* pointer-events: none; */
  text-decoration: none;
}

.login-resend-countdown {
  margin-left: 8px;
  font-size: 13px;
  font-family: var(--font-family-primary);
  color: #B6B8D8;
}
  .MuiTypography-root.login-verify{
    font-size: 16px;
    font-family: var(--font-family-primary);
    font-weight: 400;
    color: #F0F0F0;
    margin-bottom: 10px;
  }
     .MuiTypography-root.login-des{
    font-size: 14px;
    font-family: var(--font-family-primary);
    font-weight: 400;
    color: #F0F0F0;
    margin-bottom: 10px;
  }
  `, "",{"version":3,"sources":["webpack://./src/components/Signup/Signup.css"],"names":[],"mappings":";EACE,KAAK;EACL;IACE,aAAa;IACb,aAAa;IACb,gBAAgB;EAClB;EACA;IACE,SAAO;IACP,cAAc;EAChB;;EAEA;IACE,SAAO;IACP,8DAA8D;IAC9D,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,gBAAgB;EAClB;;EAEA,qBAAqB;EACrB;IACE,WAAW;IACX,uBAAuB;;EAEzB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,gDAAgD;IAChD,6BAA6B;EAC/B;;EAEA;IACE,iDAAiD;IACjD,6BAA6B;EAC/B;;EAEA,gCAAgC;EAChC;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,sBAAsB;EACxB;EACA;IACE,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;EACA,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;EAEE,kBAAkB;EAClB;IACE,yBAAyB;IACzB,WAAW;IACX,aAAa;IACb,uCAAuC;IACvC,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,oBAAoB;EACtB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,uCAAuC;IACvC,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;;EAElB;EACA;IACE,WAAW;IACX,qBAAqB;IACrB,gBAAgB;;EAElB;EACA;IACE,WAAW;IACX,qBAAqB;IACrB,gBAAgB;IAChB,iBAAiB;;EAEnB;EACA;IACE,0BAA0B;;EAE5B;CACD;IACG,cAAc;CACjB;CACA;IACG,cAAc;;CAEjB;GACE;IACC,eAAe;IACf,uCAAuC;IACvC,gBAAgB;IAChB,cAAc;IACd,mBAAmB;EACrB;EACA;IACE,eAAe;IACf,uCAAuC;IACvC,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,mBAAmB;IACnB,0BAA0B;EAC5B;EACA;IACE,WAAW;IACX,gBAAgB;IAChB,0BAA0B;IAC1B,eAAe;EACjB;EACA;IACE,eAAe;IACf,uCAAuC;IACvC,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,cAAc;EAChB;CACD;EACC,4BAA4B;EAC5B,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,2BAA2B;EAC3B,iGAAiG;EACjG;GACC,iGAAiG;EAClG;EACA;IACE,iGAAiG;GAClG;AACH;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,yBAAyB;IACzB,uBAAuB;IACvB,SAAS;AACb;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,6BAA6B;EAC7B,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,qBAAqB;AACvB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,WAAW;AACf;AACA;IACI,kBAAkB;AACtB;AACA;GACG,eAAe;EAChB,uCAAuC;EACvC,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,mBAAmB;CACpB,0BAA0B;EACzB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,uCAAuC;EACvC,cAAc;AAChB;EACE;IACE,eAAe;IACf,uCAAuC;IACvC,gBAAgB;IAChB,cAAc;IACd,mBAAmB;EACrB;KACG;IACD,eAAe;IACf,uCAAuC;IACvC,gBAAgB;IAChB,cAAc;IACd,mBAAmB;EACrB","sourcesContent":["\n  /*  */\n  .maincontainer{\n    display: flex;\n    height: 100vh;\n    overflow: hidden;\n  }\n  .imagecontainer{\n    flex: 2;\n    display: block;\n  }\n  \n  .leftcontainer{\n    flex: 1;\n    background: linear-gradient(to top, #282B4E 50%, #383C6A 100%);\n    color: #fff;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    padding: 24px;\n    overflow-y: auto;\n  }\n  \n  /* TextField Styles */\n  .textField input {\n    color: #fff;\n    background: transparent;\n\n  }\n  \n  .textField label {\n    color: #808080;\n  }\n  \n  .textField .MuiOutlinedInput-root {\n    border-radius: 8px;\n  }\n  \n  .textField .MuiOutlinedInput-root fieldset {\n    border-color: #808080;\n  }\n  \n  .textField .MuiOutlinedInput-root:hover fieldset {\n    border-color: #A9A9A9;\n  }\n  \n  .textField .MuiOutlinedInput-root.Mui-focused fieldset {\n    border-color: #808080;\n  }\n  \n  .textField .MuiInputLabel-root {\n    color: #808080;\n  }\n  \n  .textField .MuiInputLabel-root.Mui-focused {\n    color: #808080;\n  }\n  \n  .textField input:-webkit-autofill {\n    -webkit-box-shadow: 0 0 0px 1000px #383C6A inset;\n    -webkit-text-fill-color: #fff;\n  }\n  \n  .textField input:-webkit-autofill:focus {\n    -webkit-box-shadow: 0 0 0px 1000px #383C6A  inset;\n    -webkit-text-fill-color: #fff;\n  }\n  \n  /* Password Strength Indicator */\n  .passwordStrength {\n    display: flex;\n    align-items: center;\n    gap: 5px;\n    /* margin-top: 33px; */\n  }\n  .passwordBar {\n    height: 5px;\n    width: 25px;\n    border-radius: 2px;\n    margin-left: 5px;\n    background-color: #808080;\n  }\n  \n  .passwordBar.strong {\n    background-color: #3FC014;\n  }\n  \n  .passwordBar.medium {\n    background-color: #FFFF00;\n  }\n  .passwordBar.weak {\n    background-color: #b10c0c;\n  }\n  .passwordMessage .weak {\n  color: red;\n}\n\n.passwordMessage .medium {\n  color: yellow;\n}\n\n.passwordMessage .strong {\n  color: green;\n}\n  \n  /* Button Styles */\n  .MuiButtonBase-root.submitButton {\n    background-color: #69319d;\n    color: #fff;\n    padding: 10px;\n    font-family: var(--font-family-primary);\n    font-size: 14px;\n    font-weight: 400;\n    border-radius: 8px;\n    text-transform: none;\n  }\n  \n  .MuiButtonBase-root.submitButton:hover {\n    background-color: #53297d;\n  }\n  \n  .MuiTypography-root.policyText {\n    font-family: var(--font-family-primary);\n    font-size: 14px;\n    font-weight: 400;\n    text-align: center;\n    margin-top: 12px;\n \n  }\n  .MuiTypography-root.policyText .Privacy{\n    color: #fff;\n    text-decoration: none;\n    margin-left: 4px;\n\n  }\n  .MuiTypography-root.policyText .Terms{\n    color: #fff;\n    text-decoration: none;\n    margin-left: 2px;\n    margin-right: 4px;\n\n  }\n  .MuiInputBase-root{\n    background-color: #282B4E ;\n\n  }\n .VisibilityOff{\n    color: #8E37E6;\n }\n .Visibility{\n    color: #8E37E6;\n\n }\n   .MuiTypography-root.login-short{\n    font-size: 12px;\n    font-family: var(--font-family-primary);\n    font-weight: 400;\n    color: #F0F0F0;\n    margin-bottom: 10px;\n  }\n  .login-resend{\n    font-size: 13px;\n    font-family: var(--font-family-primary);\n    font-weight: 600;\n    color: #BD77FF;\n    cursor: pointer;\n    margin-bottom: 30px;\n    text-decoration: underline;\n  }\n  .login-resend-timer{\n    color: #fff;\n    margin-left: 5px;\n    text-decoration: underline;\n    cursor: pointer;\n  }\n  .MuiTypography-root.login-title{\n    font-size: 16px;\n    font-family: var(--font-family-primary);\n    font-weight: 400;\n    color: #F0F0F0;\n    margin-bottom: 20px;\n    line-height: 1;\n  }\n .MuiBox-root.imagecontainer{\n  background-repeat: no-repeat;\n  object-fit: cover;\n  width: 100%;\n  height: 100%;\n  background-size: cover;\n  background-position: center;\n  background-image: url('https://showcasaai.blob.core.windows.net/applicationasset/1440_Image.svg');\n  @media screen and (min-width: 1024px) and (max-width: 1440px) {\n   background-image: url('https://showcasaai.blob.core.windows.net/applicationasset/1440_Image.svg');\n  }\n  @media screen and (min-width: 1441px) {\n    background-image: url('https://showcasaai.blob.core.windows.net/applicationasset/1920_Image.svg');\n   }\n}\n.MuiBox-root.login-container{\n    display: flex;\n    flex-direction: column;\n    /* align-items: center; */\n    justify-content: center;\n    gap: 10px;\n}\n.otp-input {\n  width: 48px;\n  height: 56px;\n  text-align: center;\n  font-size: 24px;\n  font-weight: 600;\n  border: 2px solid #4A4E7C;\n  border-radius: 8px;\n  outline: none;\n  transition: border-color 0.2s;\n  background-color: #4A4E7C;\n  color: #fff;\n}\n\n.otp-input:focus {\n  border-color: #6a6fad; \n}\n.MuiBox-root.verification-container{\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n    width: 100%;\n}\n.textField.verification-email .MuiFormHelperText-root {\n    margin-bottom: 0px;\n}\n.MuiTypography-root.extra-login-text{\n   font-size: 14px;\n  font-family: var(--font-family-primary);\n  font-weight: 400;\n}\n.login-resend.disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n /* pointer-events: none; */\n  text-decoration: none;\n}\n\n.login-resend-countdown {\n  margin-left: 8px;\n  font-size: 13px;\n  font-family: var(--font-family-primary);\n  color: #B6B8D8;\n}\n  .MuiTypography-root.login-verify{\n    font-size: 16px;\n    font-family: var(--font-family-primary);\n    font-weight: 400;\n    color: #F0F0F0;\n    margin-bottom: 10px;\n  }\n     .MuiTypography-root.login-des{\n    font-size: 14px;\n    font-family: var(--font-family-primary);\n    font-weight: 400;\n    color: #F0F0F0;\n    margin-bottom: 10px;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
